import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import images from "../../../../../../../../../utilities/images/images";
import "./HandbookCouponList.scss";

const HandbookCouponList = ({
  couponCode,
  setCouponCode,
  applyCoupon,
  handleCloseCoupon,
  checkApplyCouponBtnDisabled,
  handleOnChangeCouponCode,
}) => {
  const [couponList, setCouponList] = useState(null);

  useEffect(() => {
    getCouponList();
  }, []);

  const getCouponList = async () => {
    try {
      const response = await axios.get(
        `https://learning.motion.ac.in/motioneducation/api/v1/handbook_couponlist`
      );

      if (response.data.status === 200) {
        setCouponList([...response.data.data.coupon_list]);
      }
    } catch (error) {}
  };

  return (
    <Modal
      show={true}
      onHide={handleCloseCoupon}
      dialogClassName="couponlist_modal"
       centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="coupon-wrapper">
          <h3>Coupon List</h3>
          {/* <div className="header">
            <div className="title">
              <img src={images.coupon} alt="Coupon icon" />
              <span>Coupon</span>
            </div>
          </div> */}
          <div className="coupon-input">
            <input
              type="text"
              placeholder=" Enter Coupon Code"
              value={couponCode}
              onChange={(e) => handleOnChangeCouponCode(e)}
            />
            <button
              onClick={applyCoupon}
              className={checkApplyCouponBtnDisabled}
            >
              Apply
            </button>
          </div>
          <div className="coupon-list">
            {couponList?.map((coupon) => {
              return (
                <div className="single-coupon-wrapper">
                  <div className="coupon-inner-wrapper">
                    <img src={images.coupon} alt="Coupon icon" />
                    <div className="coupon-details">
                      <div className="coupon">{coupon.coupon_code}</div>
                      <div className="coupon-desc">{coupon.discount_text}</div>
                    </div>
                  </div>

                  <div
                    className="apply-btn"
                    onClick={() => setCouponCode(coupon.coupon_code)}
                  >
                    <button disabled={checkApplyCouponBtnDisabled}>
                      Apply
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="done-btn" onClick={handleCloseCoupon}>
            <button style={{ backgroundColor: "#b50503" }}>Done</button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default HandbookCouponList;
